
import axios from "axios";
import store from "./store";
import router from "./routes/router";

let url = process.env.NODE_ENV !== 'development'? `${process.env.VUE_APP_API_BASE_URL}/api`: `${process.env.VUE_APP_API_BASE_URL}`;
const axiosClient = axios.create({
  baseURL: url
})
axiosClient.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${store.state.user.token}`
  return config;
})

axiosClient.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response.status === 401) {
    store.dispatch("logout").then(() => {
      router.push({name: 'login'})
    });
  } else if (error.response.status === 404) {
    router.push({name: 'NotFound'})
  }
  throw error;
})

export default axiosClient;
